import React, { FC, useMemo } from 'react';

import { WhaleIcon } from 'components/Table/WhaleIcon';

import { IParamsReq } from 'types';

import { DescriptionsWrap, StyledText, EmptyAntStyled } from './styled';

export const Empty: FC<Props> = props => {
  const { search, usedInComponent } = props;

  const { project, structure, section, status } = search;

  const isApartmentStatus = usedInComponent === 'ApartmentStatus/Floors';
  const isEngineeringStatus = usedInComponent === 'EngineeringNetStatusContent';
  const isPlacementsStatus = usedInComponent === 'PlacementsStatus/Placements';

  const emptyResponse = useMemo(
    () => project && structure && section && status,
    [project, structure, section, status],
  );

  return (
    <>
      <EmptyAntStyled
        image={<WhaleIcon />}
        data-testid='empty_id'
        description={
          <DescriptionsWrap>
            {isApartmentStatus && (
              <StyledText>
                {emptyResponse
                  ? 'Выберите другой проект, объект и секцию по которым хотите видеть статус квартир'
                  : 'Для отображения информации выберите проект, объект и секцию'}
              </StyledText>
            )}

            {isPlacementsStatus && (
              <StyledText>
                {emptyResponse
                  ? 'Выберите другой проект, объект и секцию по которым хотите видеть статус квартир'
                  : 'Выберите проект и очередь для просмотра статусов домов'}
              </StyledText>
            )}

            {isEngineeringStatus && (
              <StyledText>
                Выберите проект, объект и инженерную сеть для просмотра статуса
              </StyledText>
            )}
          </DescriptionsWrap>
        }
      />
    </>
  );
};

type Props = {
  search: IParamsReq;
  usedInComponent: string;
};
